import { States } from "../../../../../common/constants/states";
import { isJson } from "../../../../../common/helpers/json";

class AdminSchoolZoneCreateController {
  constructor(
    $state,
    $stateParams,
    LocationsModel,
    SchoolsModel,
    ZonesModel,
    FlashService,
    ZipCodeModel,
  ) {
    this.$state = $state;
    this.states = States;
    this.$stateParams = $stateParams;
    this.LocationsModel = LocationsModel;
    this.SchoolsModel = SchoolsModel;
    this.ZonesModel = ZonesModel;
    this.FlashService = FlashService;
    this.ZipCodeModel = ZipCodeModel;
    this.custom_center = false;
    this.zone_center = {};
    this.zone = { sectors: 0 };
    this.zipCodeSearchResults = [];
    this.zipcodes = [];
    this.geojson = null;

    SchoolsModel.getSchoolByID($stateParams.schoolId).then((response) => {
      this.school = response;
      this.locations = response.locations;
    });
  }

  toggleAllZipCodes() {
    this.zipCodeSearchResults = this.zipCodeSearchResults.map((zip) => {
      zip.isSelected = !zip.isSelected;
      return zip;
    });
  }

  searchZipCodes() {
    const query = { state: this.getStateFromLocationID() };
    if (this.isNumeric(this.zipCity)) {
      query.number = this.zipCity;
    } else {
      query.city = this.zipCity;
    }
    this.ZipCodeModel.getZipCodes(query).then((response) => {
      this.zipCodeSearchResults = response.zipcodes.map((zipcode) => {
        return zipcode;
      });
    });
  }

  addSelectedZipCodesToZone() {
    const selectedZipCodes = this.zipCodeSearchResults
      .filter((zipcode) => {
        return zipcode.isSelected === true;
      })
      .filter((zipcode) => {
        return zipcode.geojson.type !== "Point";
      });

    if (this.geojson !== null) {
      const features = [].concat(
        selectedZipCodes
          .filter((zipcode) => {
            const exists = this.geojson.features.find((z) => {
              return z.properties.name == zipcode.number;
            });
            return !exists;
          })
          .map((zipcode) => {
            return {
              type: "Feature",
              geometry: zipcode.geojson,
              properties: {
                name: zipcode.number,
              },
            };
          }),
      );
      features.forEach((feature) => this.geojson.features.push(feature));
    } else {
      this.geojson = {
        type: "FeatureCollection",
        features: [].concat(
          selectedZipCodes.map((zipcode) => {
            return {
              type: "Feature",
              geometry: zipcode.geojson,
              properties: {
                name: zipcode.number,
              },
            };
          }),
        ),
      };
    }
    this.zipCodeSearchResults.map((rs) => {
      rs.isSelected = false;
      return rs;
    });
  }

  removeZipCode(index) {
    this.geojson.features.splice(index, 1);
  }

  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  getStateFromLocationID() {
    const location = this.locations.find((l) => {
      return l.id == this.zone.location_id;
    });

    const address = isJson(location.address)
      ? JSON.parse(location.address)
      : location.address;
    return address.state;
  }

  createZone(isValid) {
    this.submitted = true;
    if (
      this.zone_center.street &&
      this.zone_center.city &&
      this.zone_center.state &&
      this.zone_center.state
    ) {
      this.zone.location =
        this.zone_center.street +
        "," +
        this.zone_center.city +
        "," +
        this.zone_center.state +
        "," +
        this.zone_center.zip;
    }
    if (isValid) {
      const payload = Object.assign({}, this.zone);
      if (payload.type === "POSTAL_CODE") {
        payload.zipcodes = [].concat(
          this.geojson.features.map((geom) => {
            return geom.properties.name;
          }),
        );
      }

      this.ZonesModel.createZone(payload)
        .then((response) => {
          this.FlashService.setMessage({
            type: "success",
            message: response.message,
          });
          this.zone = { sectors: 0 };
          this.$state.go(
            "drivecoach.admin.schools.zones.index",
            { schoolId: this.$stateParams.schoolId },
            { reload: true },
          );
          this.submitted = false;
          this.zone_center = {};
          this.custom_center = false;
        })
        .catch((Error) => {
          this.submitted = false;
        });
    } else {
      this.FlashService.setMessage({
        type: "error",
        message: "Please fill the form.",
      });
    }
  }
}
AdminSchoolZoneCreateController.$inject = [
  "$state",
  "$stateParams",
  "LocationsModel",
  "SchoolsModel",
  "ZonesModel",
  "FlashService",
  "ZipCodeModel",
];
export default AdminSchoolZoneCreateController;
